var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.charts),function(chart,idx){return _c('div',{key:idx,staticClass:"vx-col w-full mb-12"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(chart.name))]),_c('vue-apex-charts',{attrs:{"height":"300","options":chart.chartOptions,"series":chart.chart.series}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }